module.exports = function() {
  return new Worker(__webpack_public_path__ + "04e553b767fb5c838b29.worker.js");
};